import { useRepositoryQuery } from '@mews-commander/data-access';

export const useScimConfigurationQuery = (config?: {
    retry?: boolean | number;
    disableDefaultErrorHandler?: boolean;
}) =>
    useRepositoryQuery(
        'scimConfiguration',
        'get',
        {},
        {
            retry: config?.retry,
            meta: { disableDefaultErrorHandler: config?.disableDefaultErrorHandler },
        }
    );
